<template>
  <div class="parking-session-container">
    <div v-show="!session.id && !error" class="loader"></div>
    <div v-show="error" class="error">
      <div>
        <i class="error-icon"></i>
      </div>
      <div>
        {{ $t('parking_session.not_found') }}
      </div>
    </div>
    <div v-show="session.id">
      <div class="branding-container">
        <div class="languages">
          <a :href="locale"
             v-for="locale in locales"
             :class="[{ active: $i18n.locale === locale }, 'icon-lang-' + (locale == 'et' ? 'ee' : locale)]"
             @click.prevent="changeLocale(locale)"></a>
        </div>
        <div v-if="session.parking_provider" class="logo">
          <img :src="session.parking_provider.logo" :width="session.parking_provider.logo_meta.width"/>
        </div>
      </div>
      <div class="rows-wrapper">
        <div class="row">
          <div class="col">
            <i class="park-icon"></i>
          </div>
          <div class="col col-value">
            {{ session.zone }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span class="icon-label">{{ $t('parking_session.zone') }}</span>
          </div>
        </div>
      </div>
      <div class="rows-wrapper">
        <div class="row">
          <div class="col">
            <i class="vehicle-icon"></i>
          </div>
          <div class="col col-value">
            {{ session.vehicle_reg }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span class="icon-label">{{ $t('parking_session.vehicle_number') }}</span>
          </div>
        </div>
      </div>
      <div class="rows-wrapper">
        <div class="row">
          <div class="col">
            <i class="session-start-icon"></i>
          </div>
          <div class="col col-value">
            {{ formatDate(session.start_time) }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span class="icon-label">{{ $t('parking_session.start_time') }}</span>
          </div>
        </div>
      </div>
      <div class="rows-wrapper">
        <div class="row">
          <div class="col">
            <i class="session-end-icon"></i>
          </div>
          <div class="col col-value">
            {{ formatDate(session.end_time) }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span class="icon-label">{{ $t('parking_session.end_time') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment/moment";
import Vue from "vue";

export default {
  computed: mapGetters({
    session: 'parkings/session/session',
    error: 'parkings/session/error',
  }),
  watch: {
    $route: 'fetchParkingSession',
  },
  data() {
    return {
      locales: process.env.LANGUAGES,
    };
  },
  created() {
    this.fetchParkingSession();
  },
  mounted() {
    this.hideHeader()
  },
  methods: {
    hideHeader() {
      let headerBlock = document.getElementsByClassName('header')
      headerBlock[0].setAttribute('style', 'display:none')
    },
    fetchParkingSession() {
      if (!this.$route.params.sessionId) {
        return;
      }

      this.$store.dispatch('parkings/session/fetch', { id: this.$route.params.sessionId });
    },
    formatDate(value) {
      return value == null ? '*' : moment(value).format('DD.MM.YYYY HH:mm');
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      Vue.http.headers.common['X-Locale'] = locale;
      localStorage.setItem('locale', locale);
      moment.locale(locale);
    },
  }
};
</script>

<style lang="scss">
@import "~styles/_spinner.scss";

.page__login-content:has(.parking-session-container) {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss" scoped>
.error {
  text-align: center;
  color: red;
  font-size: 2rem;

  .error-icon {
    &:before {
      font-style: normal;
      font-family: FontAwesome;
      content: "\f071";
      color: red;
    }
  }
}

.parking-session-container {
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media screen and (min-width: 960px) {
    width: 50%;
  }

  @media screen and (min-width: 1600px) {
    width: 40%;
  }
}
.rows-wrapper {
  padding-top: 1rem;
  border-bottom: 1px solid #E1DFE0;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.col {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
}
.col-value {
  font-size: 1.2rem;
  font-weight: bold;
}
.col + .col {
  margin-left: 1rem;
  text-align: right;
}
.icon-label {
  padding-top: 0.2rem;
  padding-bottom: 0.1rem;
  font-size: 0.8rem;
}
.park-icon {
  content: '';
  display: inline-block;
  width: 44px;
  height: 26px;
  background: url('~icons/park.svg') 50% 50% no-repeat;
}
.vehicle-icon {
  content: '';
  display: inline-block;
  width: 44px;
  height: 26px;
  background: url('~icons/vehicle.svg') 50% 50% no-repeat;
}
.session-start-icon {
  content: '';
  display: inline-block;
  width: 44px;
  height: 26px;
  background: url('~icons/play.svg') 50% 50% no-repeat;
}
.session-end-icon {
  content: '';
  display: inline-block;
  width: 44px;
  height: 26px;
  background: url('~icons/stop.svg') 50% 50% no-repeat;
}

.branding-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
}

.logo {
  text-align: center;

  @media screen and (max-width: 520px) {
    img {
      width: 80%;
    }
  }
}

.languages {
  display: flex;

  a {
    display: block;
    width: 19px;
    height: 20px;
    margin-left: 13px;
    opacity: 0.4;
    transition: all 225ms ease-in-out;
    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.1));
  }

  a:hover {
    transition: all 225ms ease-in-out;
    opacity: 0.85;
    filter: drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, 0.21)) contrast(200%);
    transform: scale(1.05);
  }

  a.active {
    transition: all 225ms ease-in-out;
    opacity: 1;
    filter: drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, 0.1)) contrast(200%);
    animation: jumpInOut 225ms ease-in-out;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/parkings/ParkingSessionView.vue